import { MessageGateway } from './message-gateway.interface';

export const initMessageAPI = (apiSlice: any, gateway: MessageGateway) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Message'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getMessagesByProject: builder.query({
          query: gateway.getMessagesByProject,
          providesTags: ['Message'],
        }),
        postMessage: builder.mutation({
            query: gateway.postMessage,
            invalidatesTags: ['Message'],
          }),
        patchMessage: builder.mutation({
            query: gateway.patchMessage,
            invalidatesTags: ['Message'],
          }),
        deleteMessage: builder.mutation({
            query: gateway.deleteMessage,
            invalidatesTags: ['Message'],
          }),
      }),
      overrideExisting: false,
    });
};

export interface MessageSliceType {
  useGetMessagesByProjectQuery: Function;
  usePostMessageMutation: Function;
  usePatchMessageMutation: Function;
  useDeleteMessageMutation: Function;
}
